import { HttpClient } from "@parkschannel/next-utils";
export class ParkSafeApi {
    async approveParkSafe(data) {
        return this.client.put("/api/park-safe/approval", data);
    }
    async getParkSafe(slug) {
        return this.client.get("/api/park-safe/".concat(slug));
    }
    constructor(client = new HttpClient()){
        this.client = client;
    }
}
